// /src/pages/admin/clientes/EditCustomer.jsx
import React, { useState, useEffect } from "react";
import axios from "../../../api/axios"; // Ajusta si usas alias "api/*"
import { useParams, useNavigate } from "react-router-dom";

export default function EditCustomer() {
  const { customerId } = useParams(); // Cambié a customerId para que coincida con App.jsx
  const navigate = useNavigate();

  const [form, setForm] = useState({
    identification: "",
    name: "",
    address: "",
    phone_home: "",
    phone_mobile: "",
    email: "",
    install_date: "",
    technician: "",
    observations: "",
    latitude: "",
    longitude: "",
  });

  // Obtener datos del cliente al cargar
  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await axios.get(`/customers/${customerId}`);
        setForm({
          identification: res.data.identification || "",
          name: res.data.name || "",
          address: res.data.address || "",
          phone_home: res.data.phone_home || "",
          phone_mobile: res.data.phone_mobile || "",
          email: res.data.email || "",
          install_date: res.data.install_date || "",
          technician: res.data.technician || "",
          observations: res.data.observations || "",
          latitude: res.data.latitude || "",
          longitude: res.data.longitude || "",
        });
      } catch (err) {
        console.error(err);
        alert("Error al cargar los datos del cliente");
        navigate("/clientes");
      }
    };

    fetchCustomer();
  }, [customerId, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      await axios.put(`/customers/${customerId}`, form);
      alert("Datos guardados correctamente");
      navigate("/clientes");
    } catch (err) {
      console.error(err);
      alert("Error al guardar los datos");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">Editar Cliente: {form.name}</h1>

      <div className="grid grid-cols-2 gap-4">
        <input
          name="identification"
          placeholder="Nº Identificación"
          value={form.identification}
          onChange={handleChange}
        />
        <input
          name="name"
          placeholder="Nombres y Apellidos"
          value={form.name}
          onChange={handleChange}
        />
        <input
          name="address"
          placeholder="Dirección"
          value={form.address}
          onChange={handleChange}
        />
        <input
          name="phone_home"
          placeholder="Teléfono Casa"
          value={form.phone_home}
          onChange={handleChange}
        />
        <input
          name="phone_mobile"
          placeholder="Teléfono Móvil"
          value={form.phone_mobile}
          onChange={handleChange}
        />
        <input
          name="email"
          placeholder="Correo"
          value={form.email}
          onChange={handleChange}
        />
        <input
          type="datetime-local"
          name="install_date"
          placeholder="Fecha y Hora de instalación"
          value={form.install_date}
          onChange={handleChange}
        />
        <input
          name="technician"
          placeholder="Asignar Técnico"
          value={form.technician}
          onChange={handleChange}
        />
        <input
          name="observations"
          placeholder="Observaciones"
          value={form.observations}
          onChange={handleChange}
        />
        <input
          name="latitude"
          placeholder="Latitud"
          value={form.latitude}
          onChange={handleChange}
        />
        <input
          name="longitude"
          placeholder="Longitud"
          value={form.longitude}
          onChange={handleChange}
        />
      </div>

      <div className="mt-4 flex gap-2">
        <button
          className="bg-gray-500 px-4 py-2 rounded"
          onClick={() => navigate("/clientes")}
        >
          Cerrar
        </button>
        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={handleSave}
        >
          Guardar
        </button>
      </div>
    </div>
  );
}
